import { Indicator } from '@radix-ui/react-checkbox'
import { StyledCheckIcon, StyledRoot } from './Checkbox.styles'
import type { CheckboxProps } from './Checkbox.types'

export const Checkbox = ({
  className,
  id,
  children,
  onCheckedChange,
  uncheckedBoxColor,
  checked,
}: CheckboxProps): JSX.Element => {
  return (
    <div className={className}>
      <StyledRoot
        id={id}
        uncheckedBoxColor={uncheckedBoxColor}
        checked={checked}
        onCheckedChange={onCheckedChange}
      >
        <Indicator>
          <StyledCheckIcon width="1.2rem" height="1.2rem" />
        </Indicator>
      </StyledRoot>
      {children}
    </div>
  )
}
